<section>
    <h3>Transactions Report</h3>
    <main id="report"></main>
</section>

<script>
    import { dataStore } from '../stores';
    import { config } from '../../scripts/defaultURL';
    import { getData } from '../../scripts/rest';

    let transactionsData = ($dataStore && $dataStore.transactions) ? $dataStore.transactions : null;

    $: if (!transactionsData) getData(`${config.defaultURL}/transactions`).then((res) => {
        transactionsData = res;

        if (!$dataStore) $dataStore = {};
        $dataStore['transactions'] = transactionsData;
    });
    else calcTransactionTotals(transactionsData);

    function calcTransactionTotals(data) {
        console.log('calcTransactionTotals data:', data);
        let report = {};
            
        data.sort((a, b) => { if (!a.category) a.category = 'Uncategorized'; if (!b.category) b.category = 'Uncategorized'; if (a.category < b.category) return -1; if (a.category > b.category) return 1; return 0; }).forEach((item, i) => {
            // console.log(item.date);
            const date = new Date(item.date.split('T')[0] + 'T00:00'); // Splitting after minutes to guarantee correct date
            const Year = date.getFullYear();
            const Month = date.toLocaleDateString('default', { month: 'long' });

            // Create containers for each year
            if (!report[Year]) report[Year] = {
                Total: {
                    income: 0,
                    expense: 0
                }
            }

            // Create containers for each month
            if (!report[Year][Month]) report[Year][Month] = {
                Total: {
                    income: 0,
                    expense: 0
                }
            }

            // Create containers for each category by month
            if (!report[Year][Month][item.category]) report[Year][Month][item.category] = {
                income: 0,
                expense: 0
            }

            // Add all income/expense amounts for each container
            switch(item.income_expense) {
                case 'income':
                    report[Year].Total.income += Number(item.amount);
                    report[Year][Month].Total.income += Number(item.amount);
                    report[Year][Month][item.category].income += Number(item.amount);
                    break;
                case 'expense':
                    report[Year].Total.expense += Number(item.amount);
                    report[Year][Month].Total.expense += Number(item.amount);
                    report[Year][Month][item.category].expense += Number(item.amount);
                    break;
            }
            // if (item.income_expense == 'expense' && item.category == 'Office Space') console.table([date, item.income_expense, item.amount]);

            if (i == data.length-1) displayReport(report);
        });
    }

    function displayReport(report) {
        console.log('report', report);

        const interval = setInterval(() => {
            if (document.getElementById('report')) {
                clearInterval(interval);

                const r = document.getElementById('report');
                const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

                // Sort years in reverse order
                Object.entries(report).sort((a, b) => {return b[0] - a[0]}).forEach((arr) => {
                    // Creat H4 containing year
                    const h4 = document.createElement('h4');            
                    h4.innerText = arr[0];
                    // console.log('Year', arr[0]);

                    // Build a container for year
                    const yeardiv = document.createElement('div');
                    yeardiv.id = arr[0];
                    yeardiv.append(h4);
                    yeardiv.style.border = '1px solid #00d1b2';
                    yeardiv.style.padding = '1rem';
                    yeardiv.style.borderRadius = '0.5rem';
                    yeardiv.style.marginBlock = '1rem';

                    // Create table headers
                    const Th0 = document.createElement('th');
                    Th0.innerText = 'Category';
                    Th0.style.width = 'calc(100%/3)';
                    const Th1 = document.createElement('th');
                    Th1.innerText = 'Income ($)';
                    Th1.style.width = 'calc(100%/3)';
                    const Th2 = document.createElement('th');
                    Th2.innerText = 'Expense ($)';            
                    Th2.style.width = 'calc(100%/3)';

                    // Create table header row
                    const header = document.createElement('tr');
                    header.append(Th0);
                    header.append(Th1);
                    header.append(Th2);
                    header.style.backgroundColor = 'rgba(0, 209, 178, 0.25)';
                    
                    // Create table and insert header row
                    const table = document.createElement('table');
                    table.append(header);

                    // Create array from object values then sort months
                    const keys = Object.keys(arr[1]).sort((a, b) => {return months.indexOf(b) - months.indexOf(a)});
                    // console.log('keys', keys);
                    
                    // loop through entries
                    keys.forEach((key, x) => {
                        const entries = Object.entries(arr[1][key]);
                        // console.log('key',key,'entries', entries);
                        // Determine if key is a month
                        const month = (months.includes(key)) ? key : null;
                        if (month) {
                            // console.log('month', month);
                            // Creat H5 containing month
                            const monthh5 = document.createElement('h5');            
                            monthh5.innerText = month;

                            // Create month container
                            const monthdiv = document.createElement('div');
                            monthdiv.id = month;
                            monthdiv.style.marginBottom = '1rem';
                            monthdiv.style.borderBottom = '1px solid #00d1b2';
                            monthdiv.append(monthh5);

                            // Create table headers
                            const monthTh0 = document.createElement('th');
                            monthTh0.innerText = 'Category';
                            monthTh0.style.width = 'calc(100%/3)';
                            const monthTh1 = document.createElement('th');
                            monthTh1.innerText = 'Income ($)';
                            monthTh1.style.width = 'calc(100%/3)';
                            const monthTh2 = document.createElement('th');
                            monthTh2.innerText = 'Expense ($)';            
                            monthTh2.style.width = 'calc(100%/3)';

                            // Create table header row
                            const monthheader = document.createElement('tr');
                            monthheader.append(monthTh0);
                            monthheader.append(monthTh1);
                            monthheader.append(monthTh2);
                            monthheader.style.backgroundColor = 'rgba(0, 209, 178, 0.25)';

                            // Create table and insert header row
                            const monthtable = document.createElement('table');
                            monthtable.append(monthheader);
                            // debugger;
                            // Create array from object values
                            // const monthentries = Object.entries(item[1]);

                            // loop month entries
                            entries.forEach((entry, m) => {
                                // console.log('entry',entry);

                                const monthth = document.createElement('th');
                                monthth.innerText = entry[0];

                                const monthtd1 = document.createElement('td');
                                monthtd1.innerText = Number(entry[1].income).toLocaleString('en-us');

                                const monthtd2 = document.createElement('td');
                                monthtd2.innerText = Number(entry[1].expense).toLocaleString('en-us');
                                
                                const monthtr = document.createElement('tr');                    
                                monthtr.append(monthth);
                                monthtr.append(monthtd1);
                                monthtr.append(monthtd2);

                                monthtable.append(monthtr);

                                if (m == entries.length-1) {
                                    monthdiv.append(monthtable);
                                    yeardiv.append(monthdiv);
                                }
                            });
                        } else {
                            // Creat H5 containing month
                            const h5 = document.createElement('h5');            
                            h5.innerText = 'Year Total';
                            yeardiv.append(h5);

                            const th = document.createElement('th');
                            th.innerText = key;

                            const td1 = document.createElement('td');
                            const income = (entries[0][0] == 'income') ? entries[0][1] : entries[1][1];
                            td1.innerText = Number(income).toLocaleString('en-us');

                            const td2 = document.createElement('td');
                            const expense = (entries[0][0] == 'expense') ? entries[0][1] : entries[1][1];
                            td2.innerText = Number(expense).toLocaleString('en-us');
                            
                            const tr = document.createElement('tr');                    
                            tr.append(th);
                            tr.append(td1);
                            tr.append(td2);

                            table.append(tr);
                        }
                        
                        if (x == keys.length-1) yeardiv.append(table);
                    });

                    r.append(yeardiv);
                });
            }
        });
    }
</script>